var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('GPSReader',{on:{"route-updated":_vm.updateRoute}}),_c('OLMap',{attrs:{"route":_vm.routeInfo.route,"start":_vm.routeInfo.start,"end":_vm.routeInfo.end,"max":_vm.routeInfo.max}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }